(() => {
  if (customElements.get('prink-shipping-progress')) return;
  const instances = new Set();
  let latest = null, timer, request = 0;
  const update = cart => {
    if (!Number.isFinite(cart?.total_price)) return;
    latest = cart;
    document.dispatchEvent(new CustomEvent('pw:cart-total',{detail:cart}));
    instances.forEach(element => element.update(cart));
  };
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const element = instances.values().next().value;
      if (!element) return;
      const current = ++request;
      try {
        const response = await fetch(element.dataset.cartUrl, {headers:{Accept:'application/json'},cache:'no-store'});
        if (response.ok) {
          const cart = await response.json();
          if (current === request) update(cart);
        }
      } catch (_) { /* Retain the server-rendered cart total on a network error. */ }
    }, 100);
  };
  customElements.define('prink-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      instances.add(this);
      this.update(latest || {total_price:Number(this.dataset.total),currency:this.dataset.currency});
      if (this.dataset.placement === 'top') {
        try { this.hidden = sessionStorage.getItem('prink-shipping-top-hidden') === '1'; } catch (_) {}
        this.querySelector('button')?.addEventListener('click', () => {
          this.hidden = true;
          try { sessionStorage.setItem('prink-shipping-top-hidden','1'); } catch (_) {}
        });
      }
    }
    disconnectedCallback() { instances.delete(this); }
    update(cart) {
      if (cart.currency && cart.currency !== this.dataset.currency) { this.hidden = true; return; }
      const zone=document.documentElement.dataset.pwDeliveryZone;
      const goal = zone==='fr'||zone==='pt'?10000:zone==='other'?0:zone==='peninsula'||zone==='baleares'?4000:Number(this.dataset.goal), total = Math.max(0,cart.total_price);
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency',currency:this.dataset.currency}).format(value / 100);
      const message = goal===0 ? this.dataset.unknown : total === 0 ? this.dataset.empty.replace('__amount__',money(goal)) : total < goal ? this.dataset.remaining.replace('__amount__',money(goal-total)) : this.dataset.success;
      const text = this.querySelector('.pw-shipping__message');
      if (text.textContent !== message) text.textContent = message;
      const progress = goal>0?Math.max(0,Math.min(100,total / goal * 100)):0;
      const track = this.querySelector('[role="progressbar"]');
      if (track) { track.hidden=goal===0; track.setAttribute('aria-valuenow',Math.round(progress)); track.firstElementChild.style.width = `${progress}%`; }
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (Number.isFinite(event.cartData?.total_price)) { request++; update(event.cartData); }
      else refresh();
    });
  }
  ['cart:updated','cart:refresh','product:added'].forEach(name => document.addEventListener(name,refresh));
  document.addEventListener('pw:delivery-zone',()=>instances.forEach(element=>element.update(latest||{total_price:Number(element.dataset.total),currency:element.dataset.currency})));
  window.addEventListener('pageshow',refresh);
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(records => {
    if (records.some(record => record.target instanceof Element && !record.target.closest('prink-shipping-progress') && (record.target.id === 'CartDrawer' || record.target.classList.contains('drawer__inner') || record.target.id === 'CartDrawer-CartItems'))) refresh();
  }).observe(drawer,{childList:true,subtree:true});
  const cartPage = document.getElementById('main-cart-items');
  if (cartPage) new MutationObserver(records => {
    if (records.some(record => record.target instanceof Element && !record.target.closest('prink-shipping-progress'))) refresh();
  }).observe(cartPage,{childList:true,subtree:true});
})();
